<template>
  <div>
    <Header :headerTitle="$t('m.parkingDuration.title')" :hasBackBtn="true"></Header>
    <section v-if="resultItem!=''" style="margin-bottom:0px;">
      <h6>{{$t('m.parkingDuration.topTips')}}</h6>
      <b-card no-body id="cardsa">
        <b-tabs card>
          <b-tab
            no-body
            :title="parkingResult.title|concat($t('m.parkingDuration.hour'))"
            v-for="(parkingResult,index) in resultItem"
            :key="index"
          >
            <b-card-footer>
              <ul>
                <li
                  v-for="(item,indexs) in parkingResult.list"
                  :key="indexs"
                  @click="selectItem(item)"
                >
                  <p>
                     <label><strong>{{item.hour}}</strong>
                     {{ item.hour<=1 ? $t('m.parkingDuration.hour') : $t('m.parkingDuration.hours')}}
                     </label>
                    <span>
                      <b>{{item.price}}{{$t('m.parkingDuration.CNY')}}</b>&nbsp;
                      <strong>{{item.discountPrice}}</strong> {{$t('m.parkingDuration.CNY')}}
                    </span>
                  </p>
                  <div class="zekou">
                    <span v-if="$i18n.locale=='zh_CN'">{{isVip?'VIP ':''}}{{(item.discount*10).toFixed(1) + $t('m.parkingDuration.off')}}</span>
                    <span v-if="$i18n.locale=='en_US'">{{isVip?'VIP ':''}}- {{(100-item.discount*100).toFixed(0) + $t('m.parkingDuration.off')}}</span>
                  </div>
                </li>
              </ul>
            </b-card-footer>
          </b-tab>
        </b-tabs>
      </b-card>
    </section>
    <div v-if="resultItem==''">暂无停车时长</div>
    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>
  </div>
</template>
<script>
import { pricingList } from "../api/parking.js";
import {AsyncComponent as reject} from "vue";

export default {
  name: "ParkingDuration",
  data() {
    return {
      indexs: 0,
      parkingId: "",
      resultItem: [],
      message: "", //提示信息
      tipShow: "0", //是否提示
      tipType: "" ,//提示类型
      isVip : false,
    };
  },
  methods: {
    onBacks: function() {
      window.history.back();
    },
    selectItem: function(item) {
      eventBus.$emit("hour",item.hour);
      eventBus.$emit("discountPrice",item.discountPrice);
      eventBus.$emit("discount",item.discount);
      eventBus.$emit("price",item.price);
      this.$router.back(-1);
    },
    loadPricingList: function() {
      pricingList({ parkingId: this.parkingId }).then(
        response => {
          if (response.data.status == 200) {
            this.resultItem = response.data.result;
            if(this.isVip){
              this.resultItem.forEach(e => {
                e.list.forEach(o => {
                  o.discount = o.discount * this.discount;
                  o.discountPrice = (o.discountPrice * this.discount).toFixed(2);
                })
              })
            }
          } else {
            this.tipShow = "1" + Math.random() * 1000;
            this.message = response.data.message;
            this.tipType = "warning";
          }
        },
        err => {
          reject(err);
        }
      );
    }, //提示框
    openTip() {
      this.tipDisplay = "block";
      setTimeout(() => {
        this.tipDisplay = "none";
      }, 2000);
    }
  },
  created() {
    this.isVip = localStorage.getItem('isVip') === 'true' || false;
    this.discount = parseFloat(localStorage.getItem('discount')) || 1.00;
    this.parkingId = this.$route.params.parkingId;
    this.loadPricingList();
  },
  filters: {
    concat(val,type) {
      return val + type;
    }
  }
};
</script>
<style>
section #cardsa {
  padding-top: 0  !important;
  margin-top: 0px;
  background-color: #fff !important;
  position: none !important;
}
section #cardsa .tabs {
  background-color: #fff !important;
}
section #cardsa .card-header {
  border: 0 !important;
  background-color: #fff !important;
  padding: 0px;
  padding-bottom: 5px !important;
  padding-top: 0px !important;
}
section #cardsa .card-header ul li {
  width: 33% !important;
}
section #cardsa .card-header ul li a {
  color: black;
  font-size: 13px;
}
section #cardsa .card-header ul li .active {
  font-weight: bold;
  font-size: 14px;
  background-color: transparent;
  border: 0px;
  border-bottom: 3px #0066B1 solid;
}

section #cardsa .tabs .tab-content div .card-footer {
  background-color: transparent !important;
  background-color: #fff !important;
  padding-right: 65px;
   border: 0px !important;
}
section #cardsa .tabs ul {
  padding: 0px;
}
section #cardsa .tabs ul li {
  list-style: none;
  text-align: left;
  margin-right: -5px;
}
section #cards .tab-content .card-footer {
  border: 0px !important;
}
section #cardsa .tabs ul li p {
  font-size: 13px;
  line-height: 45px;
  border-bottom: 1px #e9e9e9 solid;
}
section #cardsa .tabs ul li strong {
  font-size: 18px;
}
section #cardsa .tabs ul li b {
  font-weight: 100;
  text-decoration: line-through;
  font-size: 12px;
  color: #777474;
}
section #cardsa .tabs ul li span {
  display: inline-block;
  float: right;
  margin-right: 10px;
}
/* title居中 */
section #cardsa .card-header .nav-item a{
  text-align: center;
}
</style>
<style scoped>
header {
  text-align: left;
  border: 0;
}
header .duration {
  font-size: 15px;
}

section #cardsa ul li .zekou {
  text-align: right;
  display: inline-block;
  position: absolute;
  right:0;
  /*background: url(../assets/img/zekou.png) no-repeat;*/
  background-color: #0066B1;
  min-width: 35px;
  line-height: 16px;
  margin-top: -40px;
}


section #cardsa ul li .zekou span {
  /* display: inline-block; */
  font-size: 10px;
  color: #fff;
  position: relative;
  /* bottom: 45px; */
}
section #cardsa ul li .zekou span:before {
  content: '';
  display: block;
  width: 0;
  height: 0;
  border: 8px solid transparent;
  border-right: 8px solid #0066B1;
  position: absolute;
  top: 0;
  left: -16px;
}

.tip {
  background: #2c3e50;
  position: absolute;
  margin: auto auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 1);
  opacity: 0.3;
  border-radius: 10px;
  width: 40%;
  padding-bottom: 40%;
  height: 0px;
}
.tip img {
  margin: 10px 0;
  width: 50%;
}
.tip p {
  color: #fff;
}
</style>


